import { QXMLObject } from "./QXMLObject";
import { GetNameDefForObj } from "../utils/GetNameDefForObj.js";

export class QExcelPubRow extends QXMLObject {
  constructor() {
    super();
    this.fObj = null;
  }

  InitExcelRow(obj) {
    this.SetXMLElementName("obj");
    this.fObj = obj;
  }

  GetObj() {
    return this.fObj;
  }

  OutputSubElements(stream) {
    var obj = this.GetObj();
    var nameField = GetNameDefForObj(obj);
    var name = obj.GetFieldValue(nameField);

    var aClass = obj.GetParentClass();
    var titleDefField = aClass.GetFieldDefByID("Title");
    var title = null;
    if (titleDefField != null) title = obj.GetFieldValue(titleDefField);
    if (title == null) title = "";

    this.OutputSimpleElement("name", name, stream);
    this.OutputSimpleElement("title", title, stream);
    var n = obj.GetNumChildren();
    for (var i = 0; i < n; i++) {
      var c = obj.GetIndexChild(i);
      var rr = new QExcelPubRow();
      rr.InitExcelRow(c);
      rr.OutputToXML(stream);
    }
  }
}
